import {
  collection,
  doc,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";

class FirebaseChatService {
  subscribeToAllChats(callback) {
    const q = query(collection(db, "chats"), orderBy("lastMessageAt", "desc"));
    return onSnapshot(q, (snapshot) => {
      const chats = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      callback(chats);
    });
  }

  subscribeToChatMessages(chatId, callback) {
    const q = query(collection(db, "chats", chatId, "messages"), orderBy("createdAt", "asc"));
    return onSnapshot(q, (snapshot) => {
      const messages = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      callback(messages);
    });
  }

  async sendMessage(chatId, text, senderEmail, senderRole = "admin") {
    if (!text.trim()) return;
    const chatRef = doc(db, "chats", chatId);
    const messagesRef = collection(db, "chats", chatId, "messages");

    await addDoc(messagesRef, {
      text,
      sender: senderRole,
      email: senderEmail,
      createdAt: serverTimestamp(),
    });

    await setDoc(
      chatRef,
      {
        lastMessage: text,
        lastMessageAt: serverTimestamp(),
        lastMessageSender: senderRole,
        email: chatId,
        ...(senderRole === "support" && { adminLastRead: serverTimestamp() }),
      },
      { merge: true },
    );
  }

  async markAsReadByAdmin(chatId) {
    const chatRef = doc(db, "chats", chatId);
    await updateDoc(chatRef, {
      adminLastRead: serverTimestamp(),
    });
  }
}

export default new FirebaseChatService();
